// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".household-monthly-income-form .household-monthly-income-field{margin-top:7px}.household-monthly-income-form .household-monthly-income-field .control-label{margin-top:-4px}", ""]);
// Exports
module.exports = exports;
